// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OacI","col":"styles_col__2bzdh"};